import { useState } from 'react';

import { mensagemDeErro } from '@/lib/erros';
import { toast } from '@/ui/primitives/aviso';

/** Ação com estado de carregamento e erro em aviso (o arquivo vem por fetch autenticado). */
export function useAcao<A extends unknown[]>(executar: (...args: A) => Promise<void>) {
  const [ocupado, setOcupado] = useState(false);
  const disparar = (...args: A) => {
    setOcupado(true);
    executar(...args)
      .catch((erro: unknown) => toast.error(mensagemDeErro(erro)))
      .finally(() => {
        setOcupado(false);
      });
  };
  return { ocupado, disparar };
}
